import { render, staticRenderFns } from "./notificationsTable.vue?vue&type=template&id=538a4f3f&"
import script from "./notificationsTable.vue?vue&type=script&lang=js&"
export * from "./notificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports